const ONE_WEEK_IN_SECONDS = 60 * 60 * 24 * 7;

globalThis.joinInterestGroup = async (dspUrl) => {
  const interestGroup = {
    owner: `${dspUrl}`,
    name: 'tv',
    biddingLogicUrl: `${dspUrl}/assets/dsp/bid.js`,
    ads: [
      {
        renderUrl: `${dspUrl}/assets/dsp/default-ad.html`,
        metadata: {
          adName: 'default-ad',
        },
      },
    ],
  };

  console.log('[dsp] join interest group', JSON.stringify(interestGroup));
  navigator.joinAdInterestGroup(interestGroup, ONE_WEEK_IN_SECONDS);
  console.log('[dsp] join interest group done');
};
